import mitt from 'mitt';
import { getCurrentInstance } from 'vue';

type EventHandlers<T extends Record<string, unknown>> = {
  [K in keyof T]: (event: T[K]) => void;
};

export const emitter = mitt<any>();

export const useBusEmitter = emitter.emit;
export const useBusClean = emitter.off;

export const useBusListener = (handlers: EventHandlers<any>, set: string | string[] = []) => {
  const variants = Array.isArray(set) ? set : [set];

  const manageListeners = (eventKey: string, add: boolean) => {
    const action = add ? 'on' : 'off';

    const structures = [eventKey].filter(Boolean);
    emitter[action](structures.join('__'), handlers[eventKey] as never);

    for (const variant of variants) {
      structures.push(variant);
      emitter[action](structures.join('__'), handlers[eventKey] as never);
    }
  };

  const keys = Object.keys(handlers) as Array<keyof any>;

  keys.forEach(key => manageListeners(key, true));

  const cleanup = () => {
    keys.forEach(key => manageListeners(key, false));
  };
  const nuxtApp = useNuxtApp();
  nuxtApp.vueApp.onUnmount(cleanup);

  return cleanup;
};
